import React, { useEffect, useState } from 'react';
import { Input } from 'components/input';
import { Range, getTrackBackground } from 'react-range';

interface Props {
  values: number[] | string[];
  minValue: number | Date;
  maxValue: number | Date;
  onFinalChange: (idx: number[]) => void;
}

const SliderWithButtons = (props: Props) => {
  const { values = [], minValue, maxValue, onFinalChange } = props;
  const minIndex = minValue ? values?.findIndex((x) => x === minValue) : 0;
  const maxIndex = maxValue
    ? values?.findIndex((x) => x === maxValue)
    : values.length - 1;
  const [rangeValues, setRangeValues] = useState<number[]>([minIndex, maxIndex]);

  const onChange = (newValues: number[]) => {
    setRangeValues(newValues);
  };

  const sliderProps = {
    min: 0,
    max: values.length - 1,
    step: 1,
    values: rangeValues,
    onChange,
    onFinalChange,
    renderThumb: ({ props, isDragged }: any) => (
      <div
        {...props}
        style={{
          ...props.style,
          height: '16px',
          width: '16px',
          borderRadius: '50%',
          backgroundColor: '#F7A246',
        }}
      />
    ),
    renderTrack: ({ props, children }) => (
      <div id='filter-sliderwithbutton-props'
        {...props}
        style={{
          ...props.style,
          height: '6px',
          width: '100%',
          borderRadius: '3px',
          background: getTrackBackground({
            values: rangeValues,
            colors: ['#ccc', '#F7A246', '#ccc'],
            min: 0,
            max: values?.length - 1,
          }),
          alignSelf: 'center',
        }}
      >
        {children}
      </div>
    ),
  };

  useEffect(() => {
    setRangeValues([minIndex, maxIndex]);
  }, [minIndex, maxIndex]);

  return (
    <div
      id="sliderwithbuttons-wrapper"
      className="px-2 flex items-center w-full h-[40px] relative justify-start gap-6"
    >
      <Input
        id="sliderwithbuttons-minvalue-input"
        name="minValue"
        inputType={'text'}
        value={values[rangeValues[0]] ? values[rangeValues[0]] : 'None'}
        onInput={() => {}}
        containerStyle={{ width: '16%' }}
        disabled
      />
      <div id="sliderwithbuttons-range" className="w-8/12">
        <Range {...sliderProps} />
      </div>
      <Input
        id="sliderwithbuttons-maxvalue-input"
        name="maxValue"
        inputType={'text'}
        value={values[rangeValues[1]] ? values[rangeValues[1]] : 'None'}
        onInput={() => {}}
        containerStyle={{ width: '16%' }}
        disabled
      />
    </div>
  );
};

export default SliderWithButtons;
